import { Component } from '@angular/core';

@Component({
  selector: 'as-term-dates-page',
  template: `
    <div class="page-padding">
      <h2>Term Dates</h2>

      <h3>Summer Term 2025</h3>

      <p>
        There will be no swimming in the weeks commencing 26th May and 2nd June.
      </p>

      <h4>After-School Lessons</h4>

      <b>Tuesdays</b>

      <p>
        3:45 - 5:15 PM (Chertsey)<br />
        6:00 - 8:00 PM (Woking)<br />
        22nd April - 8th July (10 weeks)
      </p>

      <b>Thursdays</b>
      <p>
        4:00 - 6:00 PM (Chertsey)<br />
        24th April - 10th July (10 weeks)
      </p>

      <h4>Parent & Child / Pre-School Lessons</h4>

      <b>Wednesdays</b>

      <p>
        9:30 - 11:30 AM<br />
        23rd April - 9th July (10 weeks)
      </p>
    </div>
  `,
})
export class TermDatesPageComponent {}
